import React, { useState } from "react"
import { Link, Navigate, useNavigate, useLocation } from "react-router-dom"

import { MdLock } from "react-icons/md"
import { Modal, Button } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { ToastContainer, toast } from "react-toastify"

// Utility function to convert RGB to HEX
export const RgbToHex = (rgb: string): string => {
  const result = rgb.match(/\d+/g) // Extract the numbers from the rgb string
  if (!result || result.length !== 3) return rgb // Fallback if the format is incorrect

  const [r, g, b] = result.map(Number) // Convert strings to numbers
  return `#${((1 << 24) + (r << 16) + (g << 8) + b)
    .toString(16)
    .slice(1)
    .toUpperCase()}` // Convert to hex and format
}

type ColorPickerProps = {
  colors: string[] // Array of RGB colors in string format
  setColor: (color: string) => void // Function to set the selected color in the parent component
  onColorClick: () => void // New function called when a color is clicked
}

export const ColorPickerUnPremium: React.FC<ColorPickerProps> = ({
  colors,
  setColor,
  onColorClick,
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const [upgrade, setUpgrade] = useState(false)
  const handleCloseUpgrade = () => {
    setUpgrade(false)
  }

  return (
    <>
      <div style={{ display: "flex", gap: "10px" }}>
        <div
          style={{
            width: "28px",
            height: "28px",
            borderRadius: "50%",
            border: "2px solid grey",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexShrink: 0,
            cursor: "pointer",
            backgroundColor: "#000000", // Display original RGB color
          }}
          onClick={() => setColor("rgb(0, 0, 0)")}

          // onClick={() => setUpgrade(true)}
        ></div>

        {colors.map((color, index) => (
          <div
            key={index}
            style={{
              width: "28px",
              height: "28px",
              borderRadius: "50%",
              border: "2px solid grey",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexShrink: 0,
              cursor: "pointer",
              backgroundColor: RgbToHex(color), // Display original RGB color
            }}
            // onClick={() => setUpgrade(true)}
            onClick={onColorClick}
          >
            <MdLock
              style={{
                width: "12.89px",
                height: "12.89px",
              }}
            />
          </div>
        ))}
      </div>

      {/* <ToastContainer
        style={{ width: "90%", maxWidth: "400px", fontSize: "18px" }}
      /> */}
    </>
  )
}
